import React  from 'react';
import {Row, Column, Container, FlexSpan} from './layoutComponents';
import {Paper, H2, H4, H5, HeaderContainer, HeroHeaderImg, HeaderOverlay, HeaderText, SideNav, NavOverlay, QuoteBlock, Quote, Quotation, Span, Avatar, MouseText, DottedSpan, StatColumn} from './styledComponents';
import {ProxiedButton} from './interfaces';

export const UI = props =>{
  let fields;
  let message=<H4 centered>Stats unavailable offline.</H4>;
  let mousey=<MouseText>Check back later.</MouseText>
  let avatar;
  if(props.memberTotal){
    message=<H4 centered>Coffee tracking results for this month</H4>;
    mousey=<MouseText>Updated hourly.</MouseText>;
  fields = <Column>
            <Row middle><H4 centered>Active members:</H4><DottedSpan /> <H4>{props.memberTotal}</H4></Row>
            <Row middle><H4 centered>Coffees in the last hour:</H4><DottedSpan /><H4>{props.coffeesThisHour}</H4></Row>
            <Row middle><H4 centered>Coffees this month:</H4><DottedSpan /><H4>{props.coffeeTotal}</H4></Row>
          </Column>;
  }
  if(props.user){
  if(props.user.photoURL){
    avatar= props.user.photoURL;
  }
}
  if(!props.online){
    avatar= "./profile-default.jpg";
  }

  return(
    <Container>
      <div>
     <SideNav>
        <p>Im a sidenav</p>
      </SideNav>
        <NavOverlay />
      </div>

      {/*<!--put routing here -->*/}
      <HeaderContainer>
        <HeroHeaderImg background="https://firebasestorage.googleapis.com/v0/b/leafletv2.appspot.com/o/theme-assets%2Fleaflet_profile_header-02.png?alt=media&token=90aa8be5-c1f9-4d04-a83d-0d9c48bff336" >
        <HeaderText>Are you ready to write some code {props.user.displayName}?</HeaderText>
         </HeroHeaderImg>
       </HeaderContainer>
         <Row stack middle>
      <Paper colWidth="100%" colMaxWidth="400px" colWidthSm="90%" paperMinHeight="250px" paperVertAlign="space-between">


      <Avatar avatarMargin="-60px" avatarImg="https://firebasestorage.googleapis.com/v0/b/leafletv2.appspot.com/o/theme-assets%2Fgroup_icon.png?alt=media&token=72957c04-188c-4844-adff-d0990eff739b" />

          <Container space="0px 0px 20px 0px">
              <H2>ODD101</H2>
              <H4>Class Stats:</H4>
          </Container>
          <hr />
          <Row rowAlign="space-around">
                    <StatColumn colAlign="center"><h2>19</h2><Span iconFont="0.65em">Total Students</Span></StatColumn>
                    <StatColumn colAlign="center"><h2>23</h2><Span iconFont="0.65em">Total Repos</Span></StatColumn>
                    <Column colAlign="center"><h2>7</h2><Span iconFont="0.65em">Avg. Commits/Repo</Span></Column>
                  </Row>
                    <Row middle space="30px 0px"><H4 centered>Last Commit By:</H4><Span spanPadding="10px 10px">Elon @ 21:47</Span></Row>
      </Paper>
      <Paper colWidth="100%" colMaxWidth="400px" colWidthSm="90%" paperMinHeight="250px" paperVertAlign="space-between" colOrder="-1">

      <Avatar avatarMargin="-60px" avatarImg={avatar} />

      <Container space="0px 0px 20px 0px">
          <H2>Your Stats</H2>
          <H4>Have you been coding?</H4>
      </Container>
          <Row rowAlign="space-around">
                    <StatColumn colAlign="center"><h2>5</h2><Span iconFont="0.65em">Total Repos Created</Span></StatColumn>
                    <StatColumn colAlign="center"><h2>9</h2><Span iconFont="0.65em">Avg. Commits/Repo</Span></StatColumn>
                    <Column colAlign="center"><h2>10</h2><Span iconFont="0.65em">Longest Streak (days)</Span></Column>
                  </Row>
                    <Row middle space="30px 0px"><H4 centered>Latest Merge:</H4><Span spanPadding="10px 10px">link? or time?</Span></Row>
          <Row>
            <ProxiedButton action={props.action} label="Code" />
          </Row>
      </Paper>
</Row>
      <QuoteBlock><Quote><Quotation className="icon-quote-left"></Quotation>With great code, comes great problem solving.</Quote></QuoteBlock>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/ui.js